import { pickBy, has, forEach, omit, every } from 'lodash';

class FormProcessor {
  constructor() {
    this.run = this.run.bind(this);
    this.initialSchema = {};
    this.initialUiSchema = {};
  }

  run(opts) {
    Object.assign(this, opts);

    const {
      schema,
      uiSchema,
      formData,
    } = this;

    const conditionalFields = pickBy(uiSchema, field => has(field, 'condition'));

    const newSchema = Object.assign({}, schema);
    const newUiSchema = Object.assign({}, uiSchema);
    let newFormData = Object.assign({}, formData);

    forEach(conditionalFields, (fieldValue, fieldKey) => {
      const { rules } = fieldValue.condition;
      const matches = [];

      rules.forEach((rule) => {
        const { field, value } = rule;

        if (has(newFormData, field)) {
          const currentValue = newFormData[field];

          // Operator - EQ
          if (currentValue === value) {
            matches.push(true);
          } else {
            matches.push(false);
          }
        }
      });

      // Add or remove conditional field from schema
      let shouldBeVisible = every(matches, Boolean);
      if (!matches.length) { shouldBeVisible = false; }

      if (shouldBeVisible) {
        newSchema.properties[fieldKey] = this.initialSchema.properties[fieldKey];
      } else {
        newSchema.properties = omit(newSchema.properties, [fieldKey]);
        newFormData = omit(newFormData, [fieldKey]);
      }
    });

    Object.assign(this, {
      schema: newSchema,
      uiSchema: newUiSchema,
      formData: newFormData,
    });

    return {
      schema: newSchema,
      uiSchema: newUiSchema,
      formData: newFormData,
    };
  }
}

export default FormProcessor;



// WEBPACK FOOTER //
// ./src/core/forms/form-processor.js